import React from 'react';

const ArrowLeft = ({ color = 'currentColor' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_2688_147376" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_2688_147376)">
        <path d="M7.18642 12.75L10.4787 16.0422C10.6275 16.1911 10.7009 16.3652 10.6989 16.5645C10.6971 16.7638 10.6237 16.9411 10.4787 17.0962C10.3237 17.2512 10.1455 17.3313 9.94417 17.3365C9.74283 17.3417 9.56467 17.2667 9.40967 17.1115L4.93067 12.6327C4.75 12.4519 4.65967 12.241 4.65967 12C4.65967 11.759 4.75 11.5481 4.93067 11.3672L9.40967 6.8885C9.55834 6.73983 9.73492 6.66641 9.93942 6.66825C10.1439 6.67025 10.3237 6.74875 10.4787 6.90375C10.6237 7.05891 10.6987 7.23458 10.7037 7.43075C10.7088 7.62691 10.6338 7.80258 10.4787 7.95775L7.18642 11.25H18.9519C19.1648 11.25 19.3429 11.3218 19.4864 11.4655C19.6301 11.609 19.7019 11.7872 19.7019 12C19.7019 12.2128 19.6301 12.391 19.4864 12.5345C19.3429 12.6782 19.1648 12.75 18.9519 12.75H7.18642Z" fill={color}/>
      </g>
    </svg>
  );
};

export default ArrowLeft; 